import { Stack } from '../../design-system/stack/stack';
import { ManageMembers } from './components/manage-members';

export const ManageMembersPage = () => {
  return (
    <Stack align="stretch" className="min-h-screen py-2 pr-2">
      <Stack align="stretch" className="flex-1 overflow-clip rounded-md border border-border bg-background shadow-xs">
        <ManageMembers />
      </Stack>
    </Stack>
  );
};
